'use client';

import type { Table } from '@tanstack/react-table';

import { DataTableActionBar } from '@/components/data-table/data-table-action-bar';
import type { ReportLibraryRow } from '@/app/reports/types/report-library-row';

type ReportsTableActionBarProps = {
  table: Table<ReportLibraryRow>;
};

export function ReportsTableActionBar({ table }: ReportsTableActionBarProps) {
  return <DataTableActionBar table={table} />;
}
